import type { IconData } from '@stacksjs/iconify-core'

export const keyholeLockCircleSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 46.5C11.574 46.5 1.5 36.426 1.5 24S11.574 1.5 24 1.5S46.5 11.574 46.5 24S36.426 46.5 24 46.5m6.6-26.9a6.6 6.6 0 0 1-3.095 5.594l1.642 7.392c.206.925-.28 1.847-1.208 2.042c-.913.192-2.226.372-3.939.372s-3.025-.18-3.938-.372c-.928-.195-1.414-1.117-1.208-2.043l1.642-7.391A6.6 6.6 0 1 1 30.6 19.6\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default keyholeLockCircleSolid
